import path from 'ramda/src/path'
import { modalStoreLenses } from 'root/src/client/logic/modal/lenses'
import moduleDescriptionsObj from 'root/src/shared/descriptions/modules'

const { viewModalRecordId } = modalStoreLenses

export default (state, { moduleId }) => {
	const modalId = path([moduleId, 'moduleId'], moduleDescriptionsObj)
	return viewModalRecordId(modalId, state)
}
